import {
  REWARD_POOL_TICKET_CURRENCY,
  RewardPoolTicketCurrency,
} from '@shared/api/types/rewardPools';
import { useRewardPoolSelfEntries } from '@shared/hooks/query/rewardPools';

const DEFAULT_MAP: Record<RewardPoolTicketCurrency, number> = {
  [REWARD_POOL_TICKET_CURRENCY.SQR]: 0,
  [REWARD_POOL_TICKET_CURRENCY.SQRp]: 0,
  [REWARD_POOL_TICKET_CURRENCY.USDT]: 0,
  [REWARD_POOL_TICKET_CURRENCY.FREE]: 0,
};

type Props = {
  poolId: number;
};

export const useSelfEntriesAmountByCurrency = ({ poolId }: Props) => {
  const { data: entries = [], isLoading } = useRewardPoolSelfEntries(poolId);

  const entriesAmountByCurrency = entries.reduce(
    (acc, entry) => {
      acc[entry.currency] += 1;
      return acc;
    },
    { ...DEFAULT_MAP },
  );

  return { entriesAmountByCurrency, isLoading };
};
